export const SkeletonProjectBuildCard = (props: { total?: number }) => {
  const { total = 5 } = props
  return (
    <>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className="hover-project-card p-3 bg-white border border-[#E4E4E4] rounded-[6px] cursor-pointer flex flex-col gap-2"
        >
          <div className="flex items-center">
            <div className="h-[24px] w-full bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          </div>
          <div className="flex items-center">
            <div className="h-[18px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          </div>
          <div className="flex items-center flex-wrap gap-[4px]">
            <div className="h-[20px] w-[40px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
            <div className="h-[20px] w-[40px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
            <div className="h-[20px] w-[40px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
          </div>
          <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
        </div>
      ))}
    </>
  )
}

export const SkeletonProjectBuildDetail = () => {
  return (
    <div className="flex flex-col h-full w-full">
      <div className="min-h-[74px] border-b border-[#E4E4E4] flex items-center justify-between px-[24px]">
        <div className="flex flex-col">
          <div className="h-[24px] w-[200px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          <div className="h-[18px] w-[200px] mt-[4px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
        </div>
        <div className="h-[35px] w-[200px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
      </div>
      <div className="flex flex-col flex-1 overflow-auto p-[24px] gap-[12px]">
        <div className="flex flex-col gap-[8px]">
          <div className="h-[24px] w-[200px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          <div className="flex items-center gap-[12px]">
            <div className="h-[76px] w-[260px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
            <div className="h-[76px] w-[260px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
            <div className="h-[76px] w-[260px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
          </div>
        </div>
        <div className="h-[24px] w-[200px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />

        {Array.from({ length: 2 }).map((_, index) => (
          <div
            key={index}
            className="flex flex-col bg-white pt-3 pb-3 border border-[#E4E4E4] rounded-[6px]"
          >
            <div className="flex flex-col pb-3 px-3 gap-1 border-b border-[#E4E4E4]">
              <div className="flex justify-between">
                <div className="flex flex-col gap-1">
                  <div className="h-[24px] w-[150px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />

                  <div className="flex items-center">
                    <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                    <div
                      className="hidden md:block h-1 w-1 mx-2 rounded-full"
                      style={{
                        backgroundColor: `#EFEFEF`,
                      }}
                    />
                    <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                  </div>
                </div>
                <div className="h-[35px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
              </div>

              <div className="flex items-center mt-[12px] flex-wrap gap-2">
                <div className="h-[28px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
                <div className="h-[28px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
                <div className="h-[28px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
              </div>
            </div>

            <div className="flex flex-col px-3">
              <div className="grid grid-cols-2 pb-[8px] mt-[12px]">
                <div className="flex items-center">
                  <div className="h-[24px] w-[24px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                  <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700 ml-[12px]" />
                  <div className="h-[4px] w-[4px] mx-2 rounded-full" />
                  <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                </div>

                <div className="flex items-center justify-end gap-[12px]">
                  <div className="flex gap-[12px]" style={{ flexWrap: "wrap" }}>
                    <div className="flex items-center">
                      <div className="h-[20px] w-[20px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                      <div className="h-[22px] w-[68px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                    </div>
                    <div className="flex items-center">
                      <div className="h-[20px] w-[20px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                      <div className="h-[22px] w-[68px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                    </div>
                    <div className="flex items-center">
                      <div className="h-[20px] w-[20px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                      <div className="h-[22px] w-[68px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
                    </div>
                  </div>

                  <div className="h-[35px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
